 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTDEUT_COVER from '@/components/Text/DEUT_cover'
 import TEXTDEUT_TITLEPAGE from '@/components/Text/DEUT_titlepage'
 import TEXTDEUT_IMPRINT from '@/components/Text/DEUT_imprint'
 import TEXTDEUT_CONTENTS from '@/components/Text/DEUT_contents'
 import TEXTDEUT_GENPREF from '@/components/Text/DEUT_genpref'
 import TEXTDEUT_AUTPREF from '@/components/Text/DEUT_autpref'
 import TEXTDEUT_BIBLIOG from '@/components/Text/DEUT_bibliog'
 import TEXTDEUT_ABBREV from '@/components/Text/DEUT_abbrev'
 import TEXTDEUT_INTRO from '@/components/Text/DEUT_intro'
 import TEXTDEUT_CH01 from '@/components/Text/DEUT_ch01'
 import TEXTDEUT_CH02 from '@/components/Text/DEUT_ch02'
 import TEXTDEUT_CH03 from '@/components/Text/DEUT_ch03'
 import TEXTDEUT_CH04 from '@/components/Text/DEUT_ch04'
 import TEXTDEUT_CH05 from '@/components/Text/DEUT_ch05'
 import TEXTDEUT_CH06 from '@/components/Text/DEUT_ch06'
 import TEXTDEUT_CH07 from '@/components/Text/DEUT_ch07'
 import TEXTDEUT_CH08 from '@/components/Text/DEUT_ch08'
 import TEXTDEUT_CH09 from '@/components/Text/DEUT_ch09'
 import TEXTDEUT_CH10 from '@/components/Text/DEUT_ch10'
 import TEXTDEUT_CH11 from '@/components/Text/DEUT_ch11'
 import TEXTDEUT_CH12 from '@/components/Text/DEUT_ch12'
 import TEXTDEUT_CH13 from '@/components/Text/DEUT_ch13'
 import TEXTDEUT_CH14 from '@/components/Text/DEUT_ch14'
 import TEXTDEUT_CH15 from '@/components/Text/DEUT_ch15'
 import TEXTDEUT_CH16 from '@/components/Text/DEUT_ch16'
 import TEXTDEUT_CH17 from '@/components/Text/DEUT_ch17'
 import TEXTDEUT_CH18 from '@/components/Text/DEUT_ch18'
 import TEXTDEUT_CH19 from '@/components/Text/DEUT_ch19'
 import TEXTDEUT_CH20 from '@/components/Text/DEUT_ch20'
 import TEXTDEUT_CH21 from '@/components/Text/DEUT_ch21'
 import TEXTDEUT_CH22 from '@/components/Text/DEUT_ch22'
 import TEXTDEUT_CH23 from '@/components/Text/DEUT_ch23'
 import TEXTDEUT_CH24 from '@/components/Text/DEUT_ch24'
 import TEXTDEUT_CH25 from '@/components/Text/DEUT_ch25'
 import TEXTDEUT_CH26 from '@/components/Text/DEUT_ch26'
 import TEXTDEUT_CH27 from '@/components/Text/DEUT_ch27'
 import TEXTDEUT_CH28 from '@/components/Text/DEUT_ch28'
 import TEXTDEUT_NOTES from '@/components/Text/DEUT_notes'
 import TEXTDEUT_OT from '@/components/Text/DEUT_OT'
 import TEXTDEUT_NT from '@/components/Text/DEUT_NT'
 import TEXTDEUT_THEMES from '@/components/Text/DEUT_themes'
 import TEXTAPPEN9 from '@/components/Text/appen9'
 import TEXTFIN_ACHEVE from '@/components/Text/fin_acheve'
 import TEXTIVPTBS from '@/components/Text/IVPtbs'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/DEUT_contents",
 			"name" : "Text/DEUT_contents",
 			"component" : TEXTDEUT_CONTENTS
 		},
 		{
 			"path" : "/Text/DEUT_genpref",
 			"name" : "Text/DEUT_genpref",
 			"component" : TEXTDEUT_GENPREF
 		},
 		{
 			"path" : "/Text/DEUT_autpref",
 			"name" : "Text/DEUT_autpref",
 			"component" : TEXTDEUT_AUTPREF
 		},
 		{
 			"path" : "/Text/DEUT_bibliog",
 			"name" : "Text/DEUT_bibliog",
 			"component" : TEXTDEUT_BIBLIOG
 		},
 		{
 			"path" : "/Text/DEUT_abbrev",
 			"name" : "Text/DEUT_abbrev",
 			"component" : TEXTDEUT_ABBREV
 		},
 		{
 			"path" : "/Text/DEUT_intro",
 			"name" : "Text/DEUT_intro",
 			"component" : TEXTDEUT_INTRO
 		},
 		{
 			"path" : "/Text/DEUT_ch01",
 			"name" : "Text/DEUT_ch01",
 			"component" : TEXTDEUT_CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js